import React from "react";

export const ComplementResultsTable = ({
  samplings,
  selectedSampling,
  onSamplingSelect,
  onCopyToClipboard,
}) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString("cs-CZ");
  };

  const isOutOfRange = (result) => {
    return result.is_out_of_range === "true" || result.is_out_of_range === true;
  };

  // Helper funkcia pre získanie hodnoty podľa result_type
  const getResultValue = (result) => {
    switch (result.result_type) {
      case "QUANTITATIVE":
        return result.value || "";
      case "QUALITATIVE":
        return result.text_value || "";
      case "TEXT":
        return result.text_rich_value || "";
      case "COMMENT":
        return result.comment_value || "";
      default:
        return result.value || result.text_value || "";
    }
  };

  // Helper funkcia pre zobrazenie hodnoty s jednotkami
  const renderResultValue = (result) => {
    const value = getResultValue(result);
    const units = result.parameter_units || "";

    switch (result.result_type) {
      case "QUANTITATIVE":
        return (
          <>
            {value} {units}
            {isOutOfRange(result) && (
              <span className="out-of-range-indicator"> (mimo normu)</span>
            )}
          </>
        );
      case "QUALITATIVE":
        return (
          <>
            {value}
            {isOutOfRange(result) && (
              <span className="out-of-range-indicator"> (mimo normu)</span>
            )}
          </>
        );
      case "TEXT":
        // Pre TEXT typ zobrazíme hodnotu v plnej šírke
        return <span className="text-result">{value}</span>;
      case "COMMENT":
        // Pre COMMENT typ zobrazíme komentár kurzívou
        return (
          <span className="comment-result">
            <em>{value}</em>
          </span>
        );
      default:
        return (
          <>
            {value} {units}
            {isOutOfRange(result) && (
              <span className="out-of-range-indicator"> (mimo normu)</span>
            )}
          </>
        );
    }
  };

  // Funkcia pre zobrazenie rich text hodnoty (HTML)
  const renderRichTextValue = (result) => {
    if (result.rich_text_value) {
      return (
        <div
          className="rich-text-result"
          dangerouslySetInnerHTML={{ __html: result.rich_text_value }}
        />
      );
    }
    return null;
  };

  return (
    <div className="complement-results-table-container">
      <div className="results-layout">
        {/* Ľavá strana - zoznam záznamov */}
        <div className="results-list">
          <div className="results-list-header">
            <div className="header-cell">Datum</div>
            <div className="header-cell">Čas</div>
            <div className="header-cell">Typ laboratoře</div>
            <div className="header-cell">Systém</div>
          </div>

          <div className="results-list-body">
            {samplings.map((sampling) => (
              <div
                key={sampling.id}
                className={`result-row ${
                  selectedSampling?.id === sampling.id ? "selected" : ""
                }`}
                onClick={() => onSamplingSelect(sampling)}
              >
                <div className="cell">
                  {new Date(sampling.made_at).toLocaleDateString("cs-CZ")}
                </div>
                <div className="cell">
                  {new Date(sampling.made_at).toLocaleTimeString("cs-CZ")}
                </div>
                <div className="cell">LAB</div>
                <div className="cell">EXT</div>
              </div>
            ))}
          </div>
        </div>

        {/* Pravá strana - detaily záznamu */}
        <div className="results-detail">
          {selectedSampling ? (
            <div className="detail-content">
              <div className="detail-header">
                <h3>Detail záznamu</h3>
                <button
                  className="button btn-light"
                  onClick={() => onCopyToClipboard(selectedSampling)}
                >
                  Kopírovat
                </button>
              </div>

              <div className="detail-info">
                <p>
                  <strong>Datum a čas:</strong>{" "}
                  {formatDate(selectedSampling.made_at)}
                </p>
                <p>
                  <strong>ID vzorku:</strong> {selectedSampling.external_id}
                </p>
                <p>
                  <strong>Typ laboratoře:</strong> LAB
                </p>
              </div>

              <div className="parameter-results">
                <h4>Výsledky:</h4>
                {selectedSampling.parameter_results?.map((result) => (
                  <div
                    key={result.id}
                    className={`parameter-result ${
                      isOutOfRange(result) ? "out-of-range" : ""
                    } ${
                      result.result_type
                        ? `result-type-${result.result_type.toLowerCase()}`
                        : ""
                    }`}
                  >
                    <div className="parameter-name">
                      {result.parameter_name} ({result.parameter_abbreviation})
                    </div>
                    <div className="parameter-value">
                      {renderResultValue(result)}
                      {result.rich_text_value && renderRichTextValue(result)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="no-selection">
              <p>Vyberte záznam ze seznamu pro zobrazení detailů</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
